import NoticeContainer from './link-notice-container';

const containers = {};

const defaultOptions = {
    vertical: 'end',
    horizontal: 'end',
    type: 'primary',
    message: 'this is notice message',
    title: null,
    closable: true,
};

export default {
    show(options) {
        defaultOptions.title = LinkVue.$t('LinkForm.notify')
        let o = Object.assign({}, defaultOptions, options);
        let container = containers[`${o.horizontal}-${o.vertical}`];
        if (!container) {
            container = NoticeContainer.newInstance({horizontal: o.horizontal, vertical: o.vertical});
            containers[`${o.horizontal}-${o.vertical}`] = container;
        }
        return container.addNotice(o);
    },
};
